// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__F2ONu"};